module.exports = __webpack_public_path__ + "img/48.aff6b2da.svg";